import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard,
  Inbox,
  Users,
  FileText,
  Receipt,
  ImageIcon,
  Settings,
  LogOut,
  ExternalLink,
  MessageSquareQuote,
} from "lucide-react";

const ITEMS = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/demandes", label: "Demandes", icon: Inbox },
  { to: "/admin/clients", label: "Clients", icon: Users },
  { to: "/admin/devis", label: "Devis", icon: FileText },
  { to: "/admin/factures", label: "Factures", icon: Receipt },
  { to: "/admin/realisations", label: "Réalisations", icon: ImageIcon },
  { to: "/admin/temoignages", label: "Témoignages", icon: MessageSquareQuote },
  { to: "/admin/parametres", label: "Paramètres", icon: Settings },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-background text-foreground" data-testid="admin-layout">
      <aside className="md:w-[260px] md:min-h-screen border-b md:border-b-0 md:border-r border-border bg-muted/40 md:fixed md:left-0 md:top-0 md:bottom-0 flex flex-col">
        <div className="p-6 border-b border-border">
          <Link to="/" className="block group" data-testid="admin-brand">
            <p className="font-serif text-xl leading-tight group-hover:text-primary transition-colors">
              Luigi Chauveau
            </p>
            <p className="text-serial mt-1">Espace gestion</p>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1" data-testid="admin-nav">
          {ITEMS.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-[13.5px] transition-colors ${
                  isActive
                    ? "bg-foreground text-background"
                    : "text-foreground/75 hover:bg-background hover:text-foreground"
                }`
              }
              data-testid={`admin-nav-${it.to.replace(/\//g, "-")}`}
            >
              <it.icon size={16} />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-border space-y-1">
          <Link
            to="/"
            target="_blank"
            className="flex items-center gap-3 px-3 py-2.5 text-[13.5px] text-foreground/70 hover:text-primary transition-colors"
            data-testid="admin-view-site"
          >
            <ExternalLink size={15} />
            <span>Voir le site</span>
          </Link>
          <button
            onClick={onLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 text-[13.5px] text-foreground/70 hover:text-destructive transition-colors"
            data-testid="admin-logout"
          >
            <LogOut size={15} />
            <span>Déconnexion</span>
          </button>
          <div className="px-3 pt-3 pb-2 border-t border-border mt-2">
            <p className="text-[11px] text-muted-foreground truncate">{user?.email}</p>
          </div>
        </div>
      </aside>
      <main className="flex-1 md:ml-[260px] min-w-0">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-8 md:py-12">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
